import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MessageNameAvatarComponent } from 'app/shared/components/molecules/message-name-avatar/message-name-avatar.component';

@Component({
  selector: 'app-single-message',
  imports: [MessageNameAvatarComponent],
  templateUrl: './single-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleMessageComponent {}
